import { createContext } from "react";

export const FlipperContext = createContext<Record<string, boolean>>({});
